import { render } from "./FairQuestions.vue?vue&type=template&id=40542952&scoped=true"
import script from "./FairQuestions.vue?vue&type=script&lang=js"
export * from "./FairQuestions.vue?vue&type=script&lang=js"

import "./FairQuestions.vue?vue&type=style&index=0&id=40542952&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40542952"]])

export default __exports__